import { Component, Input } from '@angular/core';
import { ProfAiInsight } from '../../models/analytics.types';

@Component({
  selector: 'tangram-pa-ai-insights-tab',
  templateUrl: './ai-insights-tab.component.html',
  styleUrls: ['./ai-insights-tab.component.scss']
})
export class AiInsightsTabComponent {
  @Input() aiInsights: ProfAiInsight[] = [];

  loading = false;
  generated = false;

  trigger(): void {
    this.loading = true;
    this.generated = false;
    setTimeout(() => {
      this.loading = false;
      this.generated = true;
    }, 1800);
  }
}
